import React, { JSX, FC, useMemo, useEffect, useState } from "react";
import { IFormFields, ProductMasterPropertyType } from "pages/ImportMasterPage";
import { FormInstance } from "antd/es/form/Form";
import { fetchProperties } from "redux/thunks/products.thunk";
import { handleError } from "utils/handleError";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux/store/store";

import { Form } from "antd";
import GhostButton from "components/ui/GhostButton/GhostButton";
import PropertyItem from "./PropertyItem/PropertyItem";
import Hint from "components/ui/Hint/Hint";
import PropertiesListInfoModal from "components/modals/PropertiesListInfoModal/PropertiesListInfoModal";

interface IPropertiesProps {
  form: FormInstance<IFormFields>;
  handleFocus: () => void;
  updateCharc: (e: React.FocusEvent<HTMLElement, Element>) => void;
  isFieldsDisabled: boolean;
  isEditMode: boolean;
}

const Properties: FC<IPropertiesProps> = ({
  form,
  handleFocus,
  updateCharc,
  isFieldsDisabled,
  isEditMode,
}): JSX.Element => {
  const dispatch = useDispatch<AppDispatch>();
  
  const [isShowInfoModal, setIsShowInfoModal] = useState<boolean>(false);

  useEffect(() => {
    dispatch(fetchProperties({ page: 1, page_size: 20 }))
      .catch((error) => handleError("Ошибка при получении списка свойств.", error));
  }, []);

  const isAddDisabled = useMemo(() => {
    const properties: ProductMasterPropertyType[] = form.getFieldValue("properties") || [];

    if (!properties.length) return false;

    const lastProperty: ProductMasterPropertyType = properties?.at(-1);

    return !lastProperty?.propertyName || !lastProperty?.propertyValue;
  }, [form.getFieldValue("properties")]);

  const propertiesValidator = async (_, properties): Promise<void> => {
    if (
      !properties
      || properties.some(({ propertyName, propertyValue }) => !propertyName || !propertyValue)
    ) {
      return Promise.reject(
        new Error("Все свойства должны быть заполнены")
      );
    }
    return Promise.resolve();
  };

  const showInfoModal = (): void => setIsShowInfoModal(true);

  const hideInfoModal = (): void => setIsShowInfoModal(false);

  return (
    <div className="properties_wrapper mb-4">
      <div className="flex justify-between">
        <p>Свойства</p>
        <Hint text="Персональный список свойств товара" handleClick={showInfoModal} />
      </div>
      <div className="flex flex-col gap-2">
        <Form.List
          name="properties"
          rules={[{ validator: propertiesValidator }]}
        >
          {(fields, { add, remove }) => (
            <div className="properties_wrapper flex flex-col">
              {fields.map(({ key, name }) => (
                <PropertyItem
                  key={key}
                  name={name}
                  remove={remove}
                  handleFocus={handleFocus}
                  updateCharc={updateCharc}
                  isDisabled={isFieldsDisabled || !isEditMode}
                />
              ))}
              <div className="flex align-center">
                <GhostButton
                  size="large"
                  onClickHandler={() => setTimeout(() => {
                    add({ propertyName: null, propertyValue: null });
                  }, 50)}
                  text="+ Добавить свойство"
                  isDisabled={isFieldsDisabled || !isEditMode || isAddDisabled}
                >
                </GhostButton>
              </div>
            </div>
          )}
        </Form.List>
      </div>
      {isShowInfoModal && (
        <PropertiesListInfoModal
          isOpen={isShowInfoModal}
          onCancelHandler={hideInfoModal}
        />
      )}
    </div>
  );
};

export default Properties;
